/*
 * @Author: crazycattle
 * @Date: 2023-02-17 10:30:34
 * @Description: content
 */
import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home/index.vue";
import store from "@/store/index";
import StudyCenter from "./study_center";
import TaskCenter from "./task_Center";
import myCenter from "./my_Center";
import login from "./login";
Vue.use(VueRouter);

import Tool from "../utils/tool";

const routes = [
  {
    path: "/",
    redirect: '/home',
    meta: {
      isCorrectPage: true,
      auth: false,
    },
  },
  {
    path: "/home",
    name: "home",
    component: Home,
    meta: {
      isCorrectPage: true,
      auth: false,
    },
  },
  {
    path: "/notFound",
    name: "notFound",
    component: () => import("../views/notFound.vue"), // 懒加载
    meta: {
      isNotFound: true,
      isCorrectPage: true,
      auth: false,
    },
  },
  {
    path: "/OutGame/LiteralReading",
    name: "literalReading",
    component: () => import("../views/OutGame/literalReading.vue"), // 懒加载
    meta: {
      isNotFound: true,
      isCorrectPage: true,
      auth: false,
    },
  },
  //登录
  ...login,

  //个人中心
  ...myCenter,

  //任务中心
  ...TaskCenter,

  // 学习中心
  ...StudyCenter,
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  console.log(to);
  console.log(from);
  console.log(next);
  let token = Tool.getStorage("token");
  let memberId = Tool.getStorage("member_id");
  /*如果需要登录，当前没有登录，直接跳转到登录页*/
  if (to.meta.isCorrectPage) {
    if (
      !token &&
      !memberId &&
      to.path != "/login" &&
      to.path != "/notFound" &&
      to.path != "/OutGame/LiteralReading"
    ) {
      next({
        path: "/login",
      });
    } else {
      next();
    }
  } else {
    if (to.path == "/forgetPsw") {
      next();
    } else if (to.path == "/myDemo") {
      //此页面仅用于自测的demo
      next();
    } else {
      next({ path: "/notFound" });
    }
  }
});

export default router;
